<template>
    <div
        class="context-menu-view"
        :style="{ left: x, top: y }"
        v-if="show"
        @click.stop="() => {}"
    >
        <div
            class="menu-list"
            :class="[item.isDivider ? 'divider' : '']"
            :key="item.key"
            v-for="item in menus"
            @click.stop="() => menu_click(item)"
        >
            <span v-if="item.label" class="menu-span">{{ item.label }}</span>
        </div>
    </div>
</template>

<script>
import Event, {EventEnum} from '@/EventEmeitter';
import {UtilService} from '@/libs';
import {MenuData,MenuKey} from './key'

let callback = null;

    export default {
        data() {
            return {
                show: false,
                x: '0', // x位置
                y: '0', // y位置
                recordValue: null, // 当前操作的原数据，会原样返回
                menus: [], // 菜单值
            }
        },
        mounted() {
            Event.remove(EventEnum.CONTENT_MENU_OPEN, this.open);
            Event.on(EventEnum.CONTENT_MENU_OPEN, this.open);

            Event.on(EventEnum.GLOBAL_MOUSE_DOWN, (res) => {
                const isOut = !UtilService.matchesSelector(res.target.classList[0], 'context-menu-view');
                isOut && (this.close());
            });
        },
        unmounted() {
            Event.remove(EventEnum.CONTENT_MENU_OPEN, this.open);
        },
        methods: {
            open(x, y, menuKeys, record, fn) {
                this.x = `${x}px`;
                this.y = `${y}px`;
                this.recordValue = record;
                callback = fn || null;
                let menus = [];
                menuKeys.forEach(item => {
                    if (MenuData[item]) {
                        menus.push({
                            ...MenuData[item],
                            key: item,
                            isDivider: !!(item == MenuKey.DIVIDER),
                        })
                    }
                })
                this.menus = menus;
                this.show = true;
            },
            close() {
                this.show = false;
            },
            menu_click(_menu) {
                if (_menu.key === MenuKey.DIVIDER || _menu.children) {
                    return;
                }
                callback && callback(_menu, this.recordValue);
                this.close();
            }
        },
    }
</script>

<style lang="less" scoped>
    .context-menu-view{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1002;
        box-shadow: 0 0 12px 0 rgba(0,0,0,0.1);
        background-color: #fff;
        border: 1px solid #ebeef5;
        color: #303133;
        padding: 4px;
        padding-bottom: 0;
        font-size: 14px;
        line-height: 32px;
        border-radius: 4px;
        .menu-list{
            width: 110px;
            padding: 0 10px;
            border-radius: 4px;
            cursor: pointer;
            margin-bottom: 4px;
            &.divider{
                border-top: 1px solid #EBEEF5;
            }
        }
        .menu-list:hover{
            background: #EBEEF5;
        }
    }
</style>
